import viva_hospital from "../../assests/images/Viva_Hospital_MS.png";
import orfarm_multipurpose_ecommerse from "../../assests/images/orfarm_multipurpose_ecommerse.png";
import stepper_form from "../../assests/images/stepper_form.png";
import weather_app from "../../assests/images/weather_app.png";
import epam_pr from "../../assests/images/epam_pr.png";

export const timelineData = [
  {
    id: 1,
    date: "09/2009 - 07/2013",
    title: "National Aviation Academy",
    text: "Bachelor in Information technologies\r\n",
  },
  {
    id: 2,
    date: "10/2022 - 04/2023",
    title: "Algorithmics Global",
    text: "Frontend Development Program\r\n",
  },
  {
    id: 3,
    date: "02/2023 - 11/2023",
    title: "EPAM UpSkills",
    text: "Frontend Developer\r\n",
  },
];

export const experienceData = [
  {
    id: 1,
    date: "May 2017 - Feb 2019",
    info: {
      company: "BERSHKA",
      job: "Manager in Trainee",
      description: "Managing store operations",
    },
  },
  {
    id: 2,
    date: "Feb 2019 - May 2019",
    info: {
      company: "COMPASS LLC",
      job: "Sales Representative",
      description: "Travel Agent Things",
    },
  },
  {
    id: 3,
    date: "Oct 2022 - Present...",
    info: {
      company: "Freelance",
      job: "Web Developer",
      description: "Web Development",
    },
  },
];

export const skillsData = [
  {
    id: 1,
    title: "HTML",
    Range: "100",
  },
  {
    id: 2,
    title: "CSS",
    Range: "90",
  },
  {
    id: 3,
    title: "JavaScript",
    Range: "70",
  },
  {
    id: 4,
    title: "TypeScript",
    Range: "50",
  },
  {
    id: 5,
    title: "React",
    Range: "60",
  },
  {
    id: 6,
    title: "React Native",
    Range: "30",
  },
  {
    id: 7,
    title: "SCSS",
    Range: "80",
  },
];

export const portData = [
  {
    id: 1,
    title: "Title 1",
    description:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Fugit expedita dolorem voluptates saepe magnam facere maxime id cupiditate, adipisci quod libero, quae tempora mollitia odit perferendis ipsam voluptate ratione. Porro.",
    link: "https://www.google.com",
    image:
      "https://s3-alpha-sig.figma.com/img/43f4/857c/2ca6fea0c29869957dc9481cc4abe20e?Expires=1698624000&Signature=E6s6k6Pczi2RNFO-7MowmZKB~RgzQDp2BYT~qvVfCfeMvBYs3cmi0HitKlYEkrRM2RPBD65azTEzOhxr0Zel7DD~HgJVqfkdvSJwTv7o5VdFTPPkvmKHvL~r89-6ImXDWwPGjboE0TlRnGzgA6yrQcahNFdtoM6vah6~6PgLyHxRbvJ9~GizMJFryTK3iZNmDvR1hs59AmOWbEkYJ9qrc-kRej~JisPT1YlllTXFo5tBCXXP8yO~j6-gATCvt4GwHCYOUpyqDSeVqOpNQHlKnOszqjFUi8UUxA6ijvHGgY8PakBThosVmoH7gvsiJYgVBQu7sG8FCd6QvqEuGYs1TQ__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4",
    type: "code",
  },
  {
    id: 2,
    title: "Title 2",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam possimus accusamus nemo quis dolore culpa? Soluta aliquam impedit corrupti recusandae quidem accusantium voluptatem unde porro, fuga maiores alias error voluptate?",
    link: "https://www.google.com",
    image:
      "https://s3-alpha-sig.figma.com/img/43f4/857c/2ca6fea0c29869957dc9481cc4abe20e?Expires=1698624000&Signature=E6s6k6Pczi2RNFO-7MowmZKB~RgzQDp2BYT~qvVfCfeMvBYs3cmi0HitKlYEkrRM2RPBD65azTEzOhxr0Zel7DD~HgJVqfkdvSJwTv7o5VdFTPPkvmKHvL~r89-6ImXDWwPGjboE0TlRnGzgA6yrQcahNFdtoM6vah6~6PgLyHxRbvJ9~GizMJFryTK3iZNmDvR1hs59AmOWbEkYJ9qrc-kRej~JisPT1YlllTXFo5tBCXXP8yO~j6-gATCvt4GwHCYOUpyqDSeVqOpNQHlKnOszqjFUi8UUxA6ijvHGgY8PakBThosVmoH7gvsiJYgVBQu7sG8FCd6QvqEuGYs1TQ__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4",
    type: "code",
  },
  {
    id: 3,
    title: "Title 3",
    description:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Fugit expedita dolorem voluptates saepe magnam facere maxime id cupiditate, adipisci quod libero, quae tempora mollitia odit perferendis ipsam voluptate ratione. Porro.",
    link: "https://www.google.com",
    image:
      "https://s3-alpha-sig.figma.com/img/ff4c/1775/8604bc6106af7dbbf9d4c0238f117d54?Expires=1698624000&Signature=LhNUP9sk90vTs6EKUeie~zTmI~7b2ul3sQqf3cbSeIGGkrrwZLHoUoudjLkkz3ev9POFH4pCN-BJNiPqR-A3U6RflTudrL8GbTkjjfaLaI24Tlu0SBrb9CTiMp0DOhL1B~LDnd7M-NlBlgHyRkPrXWJyUtw7wpIydjM7iCSjvgAU67iX9O29F~JgZ4zl~S0QbPIMk0SZkpoZ42HZdcwMZaAH1isAAmRKILpa6IR6l0zLcaMGcbehKbxF49ZhsCNmWnNIae1X6fG0Hq3c1CGoQagdcmRkZ5j~Sdo2oLYuRERW1WcU8WquikPUlnp~kM6ALTPmlktcU5XNWYWxQCDjMQ__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4",
    type: "code",
  },
  {
    id: 4,
    title: "Title 4",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam possimus accusamus nemo quis dolore culpa? Soluta aliquam impedit corrupti recusandae quidem accusantium voluptatem unde porro, fuga maiores alias error voluptate?",
    link: "https://www.google.com",
    image:
      "https://s3-alpha-sig.figma.com/img/ff4c/1775/8604bc6106af7dbbf9d4c0238f117d54?Expires=1698624000&Signature=LhNUP9sk90vTs6EKUeie~zTmI~7b2ul3sQqf3cbSeIGGkrrwZLHoUoudjLkkz3ev9POFH4pCN-BJNiPqR-A3U6RflTudrL8GbTkjjfaLaI24Tlu0SBrb9CTiMp0DOhL1B~LDnd7M-NlBlgHyRkPrXWJyUtw7wpIydjM7iCSjvgAU67iX9O29F~JgZ4zl~S0QbPIMk0SZkpoZ42HZdcwMZaAH1isAAmRKILpa6IR6l0zLcaMGcbehKbxF49ZhsCNmWnNIae1X6fG0Hq3c1CGoQagdcmRkZ5j~Sdo2oLYuRERW1WcU8WquikPUlnp~kM6ALTPmlktcU5XNWYWxQCDjMQ__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4",
    type: "ui",
  },
];

export const portfolioData = [
  {
    id: 1,
    title: "Project App Template",
    description:
      "Utilized technologies such as JavaScript, Rest API, Web Worker, Webpack, Eslint, CSS, BEM, and Test tools (Mocha and Chai)",
    url: "https://mastering-javascript-events-ed1f.vercel.app/",
    image: epam_pr,
    type: "code",
  },
  {
    id: 2,
    title: "Vivo Hospital",
    description: "Utilized technologies: JavaScript, HTML, and CSS",
    url: "https://hospital-management-system-zb.netlify.app/",
    image: viva_hospital,
    type: "ui",
  },
  {
    id: 3,
    title: "Weather App",
    description: "Utilized technologies: React and Axios",
    url: "https://weather-app-zeta-six-25.vercel.app/",
    image: weather_app,
    type: "ui",
  },
  {
    id: 4,
    title: "Orfarm Multipurpose Ecommerse",
    description: "Utilized technologies such as HTML and CSS",
    url: "https://orfarm-multipurpose-ecommerse.netlify.app/",
    image: orfarm_multipurpose_ecommerse,
    type: "code",
  },
];
